// extracted by mini-css-extract-plugin
export default {"scrolls":"style_scrolls__eFyt4","rounds":"style_rounds__ZmrKq","round":"style_round__2mUfk"};